import { API_URL } from '../services/api';

export const PAYMENT_COMPLETE_PATH = '/events/payment_complete/';
export const PAYMENT_CANCEL_PATH = '/events/payment_cancel/';
const APP_BASE_PATH = import.meta.env.BASE_URL || '/';

const joinWithBasePath = (path) => {
	const normalizedBasePath = APP_BASE_PATH.endsWith('/') ? APP_BASE_PATH.slice(0, -1) : APP_BASE_PATH;
	const normalizedPath = path.startsWith('/') ? path : `/${path}`;
	return `${normalizedBasePath}${normalizedPath}` || normalizedPath;
};

export const getPaymentReturnUrl = (path) => `${window.location.origin}${joinWithBasePath(path)}`;


export const PAYMENT_SERVER_COMPLETE_PATH = 'payments/hosted/confirm/';
export const PAYMENT_SERVER_CANCEL_PATH = 'payments/hosted/cancel/';

export const getPaymentServerCallbackUrl = (path) => `${API_URL}/${path}`;

